// Provider-neutral API adapter for enquiry submissions.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Always point to the backend under /api. No REACT_APP_FORM_ENDPOINT override.
export const ENQUIRIES_ENDPOINT = `${API}/enquiries`;

export async function submitEnquiry(payload) {
  try {
    const res = await axios.post(ENQUIRIES_ENDPOINT, payload, {
      headers: { "Content-Type": "application/json" },
      timeout: 20000,
    });
    return { ok: true, data: res.data };
  } catch (err) {
    // Never surface raw axios/network errors to callers. Log for devs, return
    // a soft-failure object so the UI can show a friendly Czech message.
    // eslint-disable-next-line no-console
    console.warn("[enquiry] submit failed", err?.response?.status, err?.message);
    return { ok: false, status: err?.response?.status || 0 };
  }
}

export function readUtmParams() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || undefined,
    utm_medium: p.get("utm_medium") || undefined,
    utm_campaign: p.get("utm_campaign") || undefined,
    utm_term: p.get("utm_term") || undefined,
    utm_content: p.get("utm_content") || undefined,
    page_path: typeof window !== "undefined" ? window.location.pathname : undefined,
  };
}
